import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_auth/_side-layout/super-admin/web-browsing/',
)({
  beforeLoad: () => {
    throw redirect({ to: '/super-admin/web-browsing/configuration' });
  },
});
